module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/4-0d64dd1bded409f4aca89717dd1bde99.png";